var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e413600204d9c271897fe80988c3a69e",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.037,
    height: 28.037,
    viewBox: "0 0 28.037 28.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 14.019,
    cy: 14.019,
    r: 14.019,
    fill: "#3c5a9a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34239",
    "data-name": "Path 34239",
    d: "M332.523,92.677H329.93c-1.539,0-3.25.647-3.25,2.878.008.777,0,1.521,0,2.359H324.9v2.833h1.835V108.9h3.372v-8.208h2.226l.2-2.787h-2.485s.006-1.24,0-1.6c0-.881.917-.831.972-.831.436,0,1.285,0,1.5,0v-2.8Z",
    transform: "translate(-314.588 -86.66)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.0b0e4e864b55e6b90dc65e04f50a2af3.svg";
export { ForwardRef as ReactComponent };